"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTL_LANGUAGES = void 0;
exports.RTL_LANGUAGES = ['ar'];
